import cycleData from './shared/state';

export default {
  modules: {
    cycleData,
  },
};
